import clsx from 'clsx';
import { formatInTimeZone } from 'date-fns-tz';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React, { useCallback } from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';
import { HOME_TIME_ZONE, articleTime } from '@utils/dates';

dayjs.extend(relativeTime);

interface TimeAgoProps {
  className?: string;
  date: string;
  timeFromNow?: boolean;
}

export default function TimeAgo({ className, date, timeFromNow = false }: TimeAgoProps) {
  const hydrated = useServerSideRendering();

  const publishTime = useCallback(() => {
    if (!date) return;

    if (timeFromNow) {
      return dayjs(date).fromNow();
    } else if (dayjs(date).isSame(new Date(), 'day')) {
      return articleTime(date);
    }

    return formatInTimeZone(new Date(date), HOME_TIME_ZONE, 'MMM d, yyyy');
  }, [date, timeFromNow]);

  return (
    <time className={clsx('text-disclosure-sm', className)} title={date} dateTime={date}>
      {hydrated && publishTime()}
    </time>
  );
}
